import { useEffect, useMemo, useRef, useState } from "react"
import { MaterialReactTable } from "material-react-table"
import { Box } from "@mui/material"
import {
  ReportingFooter,
  TableHeading,
  topFooterCellStyles,
} from "./DashboardTables"
import { useSelector } from "react-redux"
import SortIcon from "@mui/icons-material/Sort"
import { colors } from "../../../../styles/commonStyles"
import CommonTable from "./CommonTable"
import DateRangePicker from "../../Dropdown/DateRangePicker"

export type User = {
  metricName: string
  mtdBudget: number
  mtdActual: number
  variance: number
}
export const DoctorsTable = ({ loading }: { loading?: boolean }) => {
  const doctorsTable = useSelector((state: any) => {
    return state.dashboard?.doctorData
  })

  const doctorTableAgg = useSelector((state: any) => {
    return state.dashboard?.doctorDataAgg
  })
  console.log(doctorTableAgg)
  const footerStyles: any = {
    align: "center",
    sx: {
      height: "50px",
      border: "1px solid #fff",
      color: "#fff",
      backgroundColor: colors.darkBlue,
      p: 0,
    },
  }

  const doctorsColumn = useMemo<any[]>(
    () => [
      {
        accessorKey: "office",
        header: "Office",
        enableSorting: false,
        Cell: ({ row }: any) => <Box>{row.original.office}</Box>,
        // size: 100,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          sx: {
            ...footerStyles.sx,
            borderBottomLeftRadius: "5px",
          },
        },
        Footer: () => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                height: "100%",
              }}
            >
              <Box
                sx={{
                  ...topFooterCellStyles,
                  pl: "40px",
                  justifyContent: "flex",
                }}
              >
                Total
              </Box>
            </Box>
          )
        },
      },
      {
        accessorKey: "provider",
        header: "Provider",
        enableSorting: false,
        // size: 100,
        Cell: ({ row }: any) => <Box>{row.original.provider}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            border: "0.5px solid #E4E4E4",
            boxShadow: "4px 0px 0px 0px rgba(213,214,227, .7)",
          },
        }),
        muiTableFooterCellProps: {
          sx: {
            ...footerStyles.sx,
          },
        },
        Footer: () => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                height: "100%",
              }}
            >
              <Box
                sx={{
                  ...topFooterCellStyles,
                  pl: "40px",
                  justifyContent: "flex",
                }}
              ></Box>
            </Box>
          )
        },
      },
      {
        accessorKey: "net_production",
        header: "Net Prod",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            ${parseFloat(row.original.net_production || 0).toLocaleString()}
          </Box>
        ),

        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            dollar: true,
          }),
      },
      {
        accessorKey: "hours",
        header: "Hours Worked",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.hours}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "production_per_hour",
        header: "Prod Per Hour",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(row.original.production_per_hour || 0).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            dollar: true,
          }),
      },
      {
        accessorKey: "hourly_production_goal",
        header: "Hourly Prod Goal",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(
              row.original.hourly_production_goal || 0,
            ).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            dollar: true,
          }),
      },
      {
        accessorKey: "patients_seen",
        header: "Patients Seen",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.patients_seen}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "production_per_visit",
        header: "Prod Per Visit",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(
              row.original.production_per_visit || 0,
            ).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            dollar: true,
          }),
      },
      {
        accessorKey: "production_per_procedure",
        header: "Prod Per Procedure",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(
              row.original.production_per_procedure || 0,
            ).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            dollar: true,
          }),
      },
      {
        accessorKey: "fills_123_surface",
        header: "# of 1,2,3 Surface",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.fills_123_surface}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "fills_4_count",
        header: "# of 4 Surface",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.fills_4_count}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "crown_count",
        header: "# Crowns",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.crown_count}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "crown_count_diagnosed",
        header: " # Crowns Diagnosed",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.crown_count_diagnosed}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "crown_conversion_ratio",
        header: "Crown Conversion Ratio",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.crown_conversion_ratio || 0}%</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "crowns_per_patients_seen",
        header: "Crowns Per Patients",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.crowns_per_patients_seen}</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "inlay_onlay_count",
        header: "# Inlays/Onlays",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.inlay_onlay_count}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
          }),
      },
      {
        accessorKey: "procedure_mix_restorative",
        header: "Procedure Mix Restorative",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_restorative} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_preventive",
        header: "Procedure Mix Preventive",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_preventive} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_endodontics",
        header: "Procedure Mix Endodontics",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_endodontics} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_implants",
        header: "Procedure Mix Implants",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_implants} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_oral_surgery",
        header: "Procedure Mix Oral Surgery",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_oral_surgery} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_diagnostic",
        header: "Procedure Mix Diagnostic",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_diagnostic} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_periodontics",
        header: "Procedure Mix Periodontics",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_periodontics} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_orthodontics",
        header: "Procedure Mix Orthodontics",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_orthodontics} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_prosthodontics",
        header: "Procedure Mix Prosthodontics",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>{row.original.procedure_mix_prosthodontics} %</Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
      {
        accessorKey: "procedure_mix_other",
        header: "Procedure Mix Other",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.procedure_mix_other} %</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            agg: doctorTableAgg,
            column: column,
            percent: true,
          }),
      },
    ],
    [doctorsTable],
  )

  return (
    <Box>
      <DateRangePicker />
      <Box
        sx={{
          m: "1.5%",
          mt: "3%",
          "& th": {
            padding: "0.5rem 0",
            alignContent: "center",
          },
        }}
      >
        <TableHeading>Doctors</TableHeading>
        <CommonTable
          data={doctorsTable || []}
          column={doctorsColumn || []}
          enableGrouping={true}
          isloading={loading}
        />
      </Box>
    </Box>
  )
}

export default DoctorsTable
